import { render, staticRenderFns } from "./auth-signup-success.vue?vue&type=template&id=873365f8&scoped=true&"
import script from "./auth-signup-success.vue?vue&type=script&lang=ts&"
export * from "./auth-signup-success.vue?vue&type=script&lang=ts&"
import style0 from "./auth-signup-success.vue?vue&type=style&index=0&id=873365f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873365f8",
  null
  
)

export default component.exports